export default "__VITE_ASSET__866eff7c__"